import { render } from "./AccountLookup.vue?vue&type=template&id=81547130"
import script from "./AccountLookup.vue?vue&type=script&lang=js"
export * from "./AccountLookup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__